function Grid(rows,cols){
  return Array(rows).fill(null).map(() => Array(cols).fill([]));
}

function getDims(args){
  let { rows, cols, design } = args;
  if( design ){
    let dims = ({
      "96-well":{ rows:8, cols:12 }
    })[design]
    if( !dims ){
      throw Error("No register design '"+design+"'");
    }
    return dims;

  }else if( !isNaN(rows) && !isNaN(cols) ){
    return { rows, cols }
  }else{
    throw Error("Plate needs either `{rows,cols}` or `design` (96-well, 384-well).");
  }
}

export default function PlateFactory(args){
  return {
    ...args,
    grid:getDims(args),
  }
}
